import axios from 'axios';
import EventBus from '@/core/event-bus';
import LoginService from './LoginService';

const http = axios.create({
  baseURL: '/api',
});

http.interceptors.request.use((config) => {
  const token = LoginService.obterToken();
  config.headers.Authorization = token;

  if (config && config.url === '/api/login') {
    return config;
  }

  return config;
});

http.interceptors.response.use(undefined,
  (err) => {
    if (err.response.status === 401 || err.response.status === 403) {
      EventBus.$emit('logout');
    }

    return Promise.reject(err);
  });

export default http;



// WEBPACK FOOTER //
// ./src/services/http.js